'use client';
import { Popover as PopoverPrimitive } from '@base-ui/react/popover';
import * as React from 'react';

import { panelElevationVariants } from '@playbooks/ui/components/component-recipes';
import { cn } from '@playbooks/ui/lib/utils';

function Popover(props: PopoverPrimitive.Root.Props) {
	return <PopoverPrimitive.Root data-slot='popover' {...props} />;
}
function PopoverTrigger(props: PopoverPrimitive.Trigger.Props) {
	return <PopoverPrimitive.Trigger data-slot='popover-trigger' {...props} />;
}
function PopoverContent({
	className,
	align = 'center',
	alignOffset = 0,
	side = 'bottom',
	sideOffset = 4,
	...props
}: PopoverPrimitive.Popup.Props &
	Pick<PopoverPrimitive.Positioner.Props, 'align' | 'alignOffset' | 'side' | 'sideOffset'>) {
	// Theme
	const rootClassName = cn(
		panelElevationVariants({ elevation: 'flyout', surface: 'raised' }),
		'z-flyout w-72 origin-(--transform-origin) rounded-panel p-4 outline-none duration-fast data-open:animate-in data-open:fade-in-0 data-open:zoom-in-95 data-closed:animate-out data-closed:fade-out-0 data-closed:zoom-out-95',
		className,
	);

	// Render
	return (
		<PopoverPrimitive.Portal>
			<PopoverPrimitive.Positioner
				align={align}
				alignOffset={alignOffset}
				side={side}
				sideOffset={sideOffset}
				className='isolate z-flyout outline-none'>
				<PopoverPrimitive.Popup data-slot='popover-content' {...props} className={rootClassName} />
			</PopoverPrimitive.Positioner>
		</PopoverPrimitive.Portal>
	);
}
function PopoverTitle({ className, ...props }: PopoverPrimitive.Title.Props) {
	// Theme
	const rootClassName = cn('font-medium text-foreground', className);

	// Render
	return <PopoverPrimitive.Title {...props} className={rootClassName} />;
}
function PopoverDescription({ className, ...props }: PopoverPrimitive.Description.Props) {
	// Theme
	const rootClassName = cn('text-sm text-foreground-body', className);

	// Render
	return <PopoverPrimitive.Description {...props} className={rootClassName} />;
}
function PopoverClose(props: PopoverPrimitive.Close.Props) {
	return <PopoverPrimitive.Close data-slot='popover-close' {...props} />;
}
export { Popover, PopoverClose, PopoverContent, PopoverDescription, PopoverTitle, PopoverTrigger };
